import { render, staticRenderFns } from "./PackComponent.vue?vue&type=template&id=7a611bc0"
import script from "./PackComponent.vue?vue&type=script&lang=js"
export * from "./PackComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports